import styled, { css, keyframes } from 'styled-components'
import { Link } from 'react-router-dom'

interface LinkContainerProps {
  $isMobile?: boolean
}
export const LinkContainer = styled(Link)<LinkContainerProps>`
  display: flex;
  width: 100%;
  border-radius: 4px;
  cursor: pointer;
  --tw-bg-opacity: 1;
  transition: all 250ms linear;

  background-color: ${({ $isMobile }) => ($isMobile ? 'rgba(27, 27, 30, var(--tw-bg-opacity))' : '')};
  padding: ${({ $isMobile }) => ($isMobile ? '10px' : '')};

  .spinner {
    padding: 0;
    width: 79%;
  }
`

export const TokenName = styled.span`
  font-size: 14px;
  color: #fff;
  margin-right: 5px;
`

export const Price = styled.span`
  font-size: 14px;
  color: #fff;
`

interface PriceChangeProps {
  $isCollapsed?: boolean
  $isPositive: boolean
}
export const PriceChange = styled.div<PriceChangeProps>`
  font-size: 14px;
  color: ${({ $isPositive }) => ($isPositive ? '#3CCEA2' : '#CE3C3C')};
  display: ${({ $isCollapsed }) => ($isCollapsed ? 'none' : 'flex')};
`

interface SectorProps {
  $isCollapsed: boolean
}
export const Sector = styled.div<SectorProps>`
  display: ${({ $isCollapsed }) => ($isCollapsed ? 'none' : 'flex')}; ;
`
export const PriceInfo = styled.div`
  z-index: 9999;
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
`

interface ArrowWrapProps {
  $isArrowUp: boolean
  $isCollapsed: boolean
}
export const ArrowWrap = styled.div<ArrowWrapProps>`
  display: flex;
  align-items: center;
  margin: ${({ $isCollapsed }) => ($isCollapsed ? '0 0 0 2px' : '0px 5px 0px 10px')};
  svg {
    ${({ $isArrowUp }) => ($isArrowUp ? '' : 'transform: scale(1, -1)')}
  }
`

export const shineAnimation = keyframes`
  from {
    filter: brightness(1);
  }
  50% {
    filter: brightness(1.5);
  }
  to {
    filter: brightness(1);
  }
`

interface LogoWrapProps {
  $isCollapsed?: boolean
}
export const LogoWrap = styled.div<LogoWrapProps>`
  width: ${({ $isCollapsed }) => ($isCollapsed ? '54px' : '50px')};
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    transition: background-color 0.2s;
    width: ${({ $isCollapsed }) => ($isCollapsed ? '54px' : '50px')};
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid;
    border-image-slice: 1;
    border-width: 2px;
    border-style: solid;

    mask: linear-gradient(#000 0 0) padding-box, linear-gradient(#000 0 0);
    mask-composite: exclude;
    border-image-source: linear-gradient(221.49deg, #14f7ba 3.65%, #e5cc3f 116.18%);
  }
`

interface StyledSvgProps {
  $loading?: boolean
}
export const StyledSvg = styled.svg<StyledSvgProps>`
  cursor: pointer;

  ${(props) =>
    props.$loading &&
    css`
      path {
        animation: ${shineAnimation} 6s ease-in-out infinite;
      }
    `}

  transition: fill 0.2s ease;
  animation: ${shineAnimation} 6s ease-in-out infinite;
`
